export interface Pagination {
  currentPage: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  last?: boolean;
}

export interface Data {
  type: string;
  columnKeys: Array<any>;
  rows: {
    content: Array<Array<any>>;
    totalElements: number;
  };
}

export default class ReportFetchResult {
  constructor(pagination: Pagination, data: Data) {
    this.pagination = pagination;
    this.data = data;
  }
  pagination: Pagination;
  data: Data;
}
